import styled from 'styled-components';
import { FaQuestion } from "react-icons/fa";
import { Heart } from 'lucide-react';
import { FaRankingStar } from "react-icons/fa6";
import { LuCross } from "react-icons/lu";
import { FaGrinStars } from "react-icons/fa";

export const QuizContainer = styled.div`
      display: flex;
      top: 5%;
      flex-direction: column;
      align-items: center;
      min-height: calc(var(--vh, 1vh) * 100);
      width: 100%;
      padding: ${props => props.theme.spacing.large};
      padding-bottom: 30%;
      position: relative;
      overflow: hidden;

      ${props => !props.isMobile &&`
      `}
`;

export const BackgroundBall = styled.div`
  position: absolute;
  width: 150vw;
  height: calc(var(--vh, 1vh) * 200);
  border-radius: 35%;
  background-color: ${props => props.theme.colors.primary};
  top: calc(25% + (40% / 2));
  left: 50%;
  transform: translateX(-50%);
  z-index: -1;

  ${props => !props.isMobile &&`
    position: absolute;
    width: 150vw;
    height: 100%;
    border-radius: 50%;
    background-color: ${props => props.theme.colors.primary};
    bottom: -40%;
    left: 50%;
    transform: translateX(-50%);
    z-index: -1;
  `}
`;

export const QuestionCard = styled.div`
  background-color: ${props => props.theme.colors.background};
  border-radius: 25px;
  padding: ${props => props.theme.spacing.xlarge};
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
  width: 70%;
  height: calc(var(--vh, 1vh) * 45);
  display: flex;
  align-items: center;
  z-index: 2;
  position: relative;
  margin-top: 15%;
  margin-left: 15%;
  transform-origin: center center;
  will-change: transform;

  ${props => !props.isMobile && `
    width: 50%;
    margin-left: 25%;
    height: calc(var(--vh, 1vh) * 60);
    margin-top: 0;
    transform: none;
  `}
`;

export const QuestionText = styled.p`
  font-size: ${props => props.theme.fontSizes.xlarge};
  color: ${props => props.theme.colors.primary};
  text-align: center;
  font-weight: ${props => props.theme.fontWeights.semiBold};
  z-index: 2;
  flex-grow: 1;
  max-height: 100%;
  margin: 0;
  padding: 0;
  flex-grow: 1;
  overflow-y: auto;
`;

export const CardWrapper = styled.div`
  position: fixed;
  width: 100%;
  top: calc(var(--vh, 1vh) * 20);
  display: flex;
  justify-content: center;
  align-items: center;
  transform-style: preserve-3d;
  perspective: 1000px;

  ${props => !props.isMobile && `
    width: 100%;
  `}
`;

export const QuizMessage = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.large};
  color: ${({ theme }) => theme.colors.text};
  text-align: center;
  padding: ${({ theme }) => theme.spacing.large};
  z-index: 2;
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: 15px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 80%;
  margin: 0 auto;
  position: absolute;
  top: calc(var(--vh, 1vh) * 20);
  left: 50%;
  transform: translate(-50%, -50%);
  border: 2px solid ${({ theme }) => theme.colors.primary};
`;

export const AnswerButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 55px;
  height: 55px;
  border-radius: 50%;
  background-color: ${props => props.theme.colors.background};
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
  }

  padding: 10px;

  &:active {
    transform: translateY(1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const QuizCompletionMessage = styled(QuizMessage)`
  font-size: ${props => props.theme.fontSizes.xlarge};
  font-weight: ${props => props.theme.fontWeights.semiBold};
  color: ${props => props.theme.colors.primary};
  background-color: ${props => props.theme.colors.lightGray};
  border: 2px solid ${props => props.theme.colors.primary};
  padding: ${props => props.theme.spacing.xlarge};

  ${props => !props.isMobile &&`
    margin-top: 35%;
  `}
`;

export const AnswerOptionsContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 80%;
  top: calc(var(--vh, 1vh) * 77);
  z-index: 3;
  position: fixed;
  gap: 6%;

  ${props => !props.isMobile &&`
    position: absolute;
    margin-bottom: 5%;
    gap: 3%;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  `}
`;

export const StyledIcon = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
  ${props => props.fill && `
    filter: drop-shadow(0 0 0 ${props.fill});
  `}
`;


const IconStyle = `
`;

export const StyledThumbsUp = styled(Heart)`
  ${IconStyle}
`;

export const StyledThumbsDown = styled(LuCross)`
  ${IconStyle}
  transform: rotate(45deg);
`;

export const StyledHelpCircle = styled(FaQuestion)`
  ${IconStyle}
`;

export const StyledHeart = styled(FaGrinStars)`
  ${IconStyle}
`;

export const ResultButton = styled(AnswerButton)`
  width: auto;
  height: auto;
  border-radius: 25px;
  padding: ${props => props.theme.spacing.medium} ${props => props.theme.spacing.large};
  font-size: ${props => props.theme.fontSizes.medium};
  font-weight: ${props => props.theme.fontWeights.medium};
  color: ${props => props.theme.colors.background};
  background-color: ${props => props.theme.colors.primary};
  margin-top: calc(var(--vh, 1vh) * 120);

  &:hover {
    background-color: ${props => props.theme.colors.accent};
  }

  svg {
    margin-right: ${props => props.theme.spacing.small};
    color: ${props => props.theme.colors.background};
  }
`;

export const StyledRanking = styled(FaRankingStar)`
  color: ${props => props.theme.colors.background};
`;

export const QuizTypeIndicator = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 8%;
  top: calc(var(--vh, 1vh) * 8);
  background-color: none;
  box-shadow: none;
  z-index: 1000;
`;

export const ProgressContainer = styled.div`
  max-width: 75%;
  margin: 0 auto;
  position: relative;
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 24px;
  background-color: rgba(230, 230, 230, 0.9);
  border-radius: 12px;
  overflow: hidden;
  position: relative;
`;

export const Progress = styled.div`
  height: 100%;
  border-radius: 12px;
  background-color: ${props => props.$isQuiz1 ? '#4CAF50' : '#2196F3'};
  width: ${props => props.$progress}%;
  transition: width 0.3s ease;
`;

export const QuizNumber = styled.div`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: white;
  font-weight: bold;
  z-index: 2;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
`;

export const ContinueModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background-color: white;
  padding: 2rem;
  border-radius: 15px;
  max-width: 500px;
  width: 90%;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const ModalTitle = styled.h2`
  color: #333;
  margin-bottom: 1rem;
  font-size: 1.5rem;
`;

export const ModalText = styled.p`
  color: #666;
  margin-bottom: 2rem;
  line-height: 1.5;
`;

export const ModalButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
`;

export const ModalButton = styled.button`
  padding: 0.8rem 1.5rem;
  border-radius: 25px;
  border: none;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s ease;

  &.continue {
    background-color: #4CAF50;
    color: white;

    &:hover {
      background-color: #45a049;
    }
  }

  &.results {
    background-color: #2196F3;
    color: white;

    &:hover {
      background-color: #1e88e5;
    }
  }
`;

export const BrandContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  padding: 16px;
  bottom: calc(var(--vh, 1vh) * 88);
  position: absolute;
  z-index: 10;
`;

export const BrandImage = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
`;

export const BrandTitle = styled.h1`
  font-size: ${props => props.fontSize || "32px"};
  color: ${props => props.fontColor || "#FF2768"};
  font-family: "Londrina Solid", sans-serif;
  font-weight: ${props => props.fontWeight || "400"};
  letter-spacing: ${props => props.letterSpacing || "normal"};
  margin: 0;
  padding: 0;
  line-height: 1.2;
  text-align: center;
  white-space: nowrap;
  text-shadow: ${props => props.textShadow || "none"};
`;